import companyApi from "./companyApi";

const cache = new Map();

const buildKey = (payload) =>
  [
    payload.period_type,
    payload.as_of_date,
    payload.calendar_year,
    payload.calendar_quarter,
    payload.calendar_month,
    payload.fiscal_year,
    payload.fiscal_quarter,
  ]
    .map((val) => (val === null || val === undefined ? "" : String(val)))
    .join("|");

export const getOrCreatePeriod = async (payload) => {
  const key = buildKey(payload);
  if (cache.has(key)) {
    return cache.get(key);
  }
  const promise = companyApi.createPeriod(payload).then((res) => res);
  cache.set(key, promise);
  return promise;
};
